<script lang="ts">
	import type { Snippet } from "svelte";
	import type { HTMLSelectAttributes } from "svelte/elements";

	const { options, ...rest }: HTMLSelectAttributes & { options: Snippet } = $props();
</script>

<select
	{...rest}
	class={[
		"rounded border min-h-[3.125rem] shadow-sm border-transparent bg-white [&:user-invalid]:border-fstphlox transition-[outline,text,border] duration-300 focus:border-fstgreen focus:[&:user-invalid]:outline-fstgreen outline-transparent outline-1 outline outline-offset-1 p-3",
		rest.class,
	]}
>
	{@render options()}
</select>
